module.exports = __webpack_public_path__ + "static/img/Bachelor_010694.fc4307a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010694.jpg
// module id = 220
// module chunks = 0